import Routes from "security-app/routing/Routes";
import { CONFIGURATION_NAV_TITLE } from "common/Constants";
export const PAGE_NAV_TITLE = "Assets";
const assetsPageNavigation = {
  description: PAGE_NAV_TITLE,
  children: [
    { description: "Assets", path: Routes.ASSETS.list("machine"), exactPathMatch: true },
    { description: "Sources", path: Routes.ASSETS.SOURCES.LIST, permissions: ["asset:edit"] },
    { description: "Vulnerability Scanners", path: Routes.ASSETS.SCANNERS.LIST, permissions: ["asset:edit"] },
    { description: CONFIGURATION_NAV_TITLE, path: Routes.ASSETS.CONFIGURATION, permissions: ["asset:edit"] }
  ]
};
export default assetsPageNavigation;
